// --- Types ---

type TutorUsageStats = {
  activeStudents: { active: number; percentage: number; total: number; trend: number };
  resolutionRate: { percentage: number; trend: number };
  studyModeUsage: { percentage: number; practicePercentage: number; trend: number };
  totalInteractions: { avgPerStudent: number; count: number; trend: number };
};

type DailyActivity = {
  interactions: number;
  name: string;
  questions: number;
};

// --- Day names by language ---

const DAY_NAMES_ES = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];
const DAY_NAMES_PT = ['Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo'];

// --- Mock stats (static values from Figma) ---

const MOCK_STATS: TutorUsageStats = {
  activeStudents: { active: 18, percentage: 72, total: 25, trend: 8 },
  resolutionRate: { percentage: 55, trend: 8 },
  studyModeUsage: { percentage: 68, practicePercentage: 32, trend: -8 },
  totalInteractions: { avgPerStudent: 24.5, count: 245, trend: 8 },
};

// --- Mock daily activity data ---

const DAILY_INTERACTIONS = [8, 10, 15, 12, 18, 20, 22];
const DAILY_QUESTIONS = [3, 5, 7, 4, 8, 6, 9];
const DAY_NUMBERS = [16, 17, 18, 19, 20, 21, 22];

// --- Helpers ---

function isPortuguese(lang: string): boolean {
  return lang.startsWith('pt');
}

function buildDailyActivity(dayNames: string[]): DailyActivity[] {
  return dayNames.map((day, index) => ({
    interactions: DAILY_INTERACTIONS[index],
    name: `${day} ${DAY_NUMBERS[index]}`,
    questions: DAILY_QUESTIONS[index],
  }));
}

// --- Export functions ---

function getMockTutorUsageStats(): TutorUsageStats {
  return MOCK_STATS;
}

function getMockDailyActivity(lang: string): DailyActivity[] {
  const dayNames = isPortuguese(lang) ? DAY_NAMES_PT : DAY_NAMES_ES;
  return buildDailyActivity(dayNames);
}

export { getMockDailyActivity, getMockTutorUsageStats };
export type { DailyActivity, TutorUsageStats };
